import { https } from './api'

// Consulta CPF v3 via api-matricula (as chaves do SERPRO ficam no servidor).
export default class {
    constructor() {
        this.instance = https('/serpro')
    }

    // nascimento: "AAAA-MM-DD" (input type="date") -> DDMMAAAA exigido pela v3
    get = (cpf, nascimento) => {
        const nasc = nascimento.split('-').reverse().join('')
        return this.instance({
            method: 'GET',
            url: `/cpf/${cpf}/${nasc}`
        });
    }
}
